import React from "react";

const ProfilePopup = ({ userDetails, handleLogout }) => {

   const handleLogoutClick = () => {
     handleLogout(); 
   };

  return (
    <div className="bg-white border rounded shadow p-4 absolute right-0 mt-16 overflow-hidden navbar_profile-popup-custom">
      <div className="flex items-center space-x-4">
        <img
          className="h-12 w-12 rounded-full cursor-pointer"
          src={userDetails.profileImageUrl}
          alt="Profile"
        />
        <div className="flex flex-col">
          <p className="text-lg font-medium">{userDetails.name}</p>
          <p className="text-gray-500 text-sm">{userDetails.email}</p>
        </div>
      </div>
      <hr className="my-5" />
      <ul className="">
        <li>
          <a href="/userprofile">Profile</a>
        </li>
        <li className="my-5">
          <a href="/usersession">Session</a>
        </li>
        <hr className="mb-2" />
        <button className="" onClick={handleLogoutClick}>Logout</button>
      </ul>
    </div>
  );
};

export default ProfilePopup;
